import { jsxs as H, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as l } from "./index.es2447.js";
function t({ size: V = l }) {
  return /* @__PURE__ */ H(
    "svg",
    {
      width: V,
      height: V,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M23 25.5C23 25.2239 23.2239 25 23.5 25H33.5C33.7761 25 34 25.2239 34 25.5V32H40.5C40.7761 32 41 32.2239 41 32.5V39.5C41 39.7761 40.7761 40 40.5 40H20.5C20.2239 40 20 39.7761 20 39.5V32.5C20 32.2239 20.2239 32 20.5 32H23V25.5Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M17 16H39V32H37C37.5523 32 38 32.4477 38 33V35C38 35.5523 37.5523 36 37 36H34C33.4477 36 33 35.5523 33 35V33C33 32.4477 33.4477 32 34 32V25.5C34 25.2239 33.7761 25 33.5 25H30C30.5523 25 31 25.4477 31 26V28C31 28.5523 30.5523 29 30 29H27C26.4477 29 26 28.5523 26 28V26C26 25.4477 26.4477 25 27 25H23.5C23.2239 25 23 25.2239 23 25.5V32H20.5C20.2239 32 20 32.2239 20 32.5V37H17V16Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M23 33C23 32.4477 23.4477 32 24 32H27C27.5523 32 28 32.4477 28 33V35C28 35.5523 27.5523 36 27 36H24C23.4477 36 23 35.5523 23 35V33Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M15.5 19.56C15.5 21.1806 16.8463 22.5 18.5 22.5C20.1537 22.5 21.5 21.1806 21.5 19.56V18.56C21.5 20.1806 22.9585 21.5 24.75 21.5C26.5415 21.5 28 20.1806 28 18.56C28 20.1806 29.4585 21.5 31.25 21.5C33.0415 21.5 34.5 20.1806 34.5 18.56V19.56C34.5 21.1806 35.8463 22.5 37.5 22.5C39.1537 22.5 40.5 21.1806 40.5 19.56V15.5H15.5V19.56Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 19.56V15H41V19.56C41 20.9347 40.1784 22.1157 39 22.6674V32L40.5 32C40.7761 32 41 32.2239 41 32.5V39.5C41 39.7761 40.7761 40 40.5 40H20.5C20.2239 40 20 39.7761 20 39.5V37H17V22.6674C15.8216 22.1157 15 20.9347 15 19.56ZM18 22.9649V36H20V32.5C20 32.2239 20.2239 32 20.5 32H23V25.5C23 25.2239 23.2239 25 23.5 25H33.5C33.7761 25 34 25.2239 34 25.5V32L38 32V22.9649C37.8366 22.988 37.6696 23 37.5 23C35.9792 23 34.6719 22.038 34.1939 20.6908C33.4984 21.4949 32.4229 22 31.25 22C29.8877 22 28.6568 21.3186 28 20.2786C27.3432 21.3186 26.1123 22 24.75 22C23.5771 22 22.5016 21.4949 21.8061 20.6908C21.3281 22.038 20.0208 23 18.5 23C18.3304 23 18.1634 22.988 18 22.9649ZM22 16H27.5V18.56C27.5 19.8585 26.3137 21 24.75 21C23.1863 21 22 19.8585 22 18.56V16ZM28.5 18.56V16H34V18.56C34 19.8585 32.8137 21 31.25 21C29.6863 21 28.5 19.8585 28.5 18.56ZM35 19.56V16H40V19.56C40 20.895 38.8871 22 37.5 22C36.1129 22 35 20.895 35 19.56ZM21 19.56V16H16V19.56C16 20.895 17.1129 22 18.5 22C19.8871 22 21 20.895 21 19.56ZM24 26V32H33V26H31V28C31 28.5523 30.5523 29 30 29H27C26.4477 29 26 28.5523 26 28V26H24ZM33 33H31V39H40V33H38V35C38 35.5523 37.5523 36 37 36H34C33.4477 36 33 35.5523 33 35V33ZM30 33H28V35C28 35.5523 27.5523 36 27 36H24C23.4477 36 23 35.5523 23 35V33H21V39H30V33ZM27 33H24V35H27V33ZM27 26H30V28H27V26ZM34 33H37V35H34V33Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricStoreSupply2Icon
};
//# sourceMappingURL=index.es425.js.map
